import { useTranslation } from 'react-i18next';
import React, { useCallback, useMemo } from 'react';
import { ImgRcSendGift } from '@/assets/pro';
import {
  PAID_FEATURE,
  useCurrentAddressInfo,
  useProfileAddress,
  useQueryPaidFeatureList,
  useSwitch,
} from '@/hooks';
import { PaidFeatureModal } from '@/views/Pro/components/PaidFeatureModal';

import styles from './index.module.scss';
import { useHistory } from 'react-router-dom';
import { useVipLeft } from '@/hooks/useVipLeft';
import Button from '../Button';
import HelperTooltip from '../HelperTooltip';
import { VipLogo } from '../VipLogo';
import { login } from '@/utils';

export const SendVipBtn = () => {
  const { t } = useTranslation();

  const { on: onPaidModal, turnOn: turnOnPaidModal, turnOff: turnOffPaidModal } = useSwitch();
  const history = useHistory();
  const { data: featuresConfig } = useQueryPaidFeatureList();
  const [urlAddress] = useProfileAddress();
  const {
    userInfo: currentUserInfo,
    address: currentAddress,
    isVerified,
  } = useCurrentAddressInfo();
  const isCurrentUser = useMemo(() => urlAddress === currentAddress, [currentAddress, urlAddress]);
  const vipLeft = useVipLeft(currentAddress!, isCurrentUser);

  const vipFeatureConfig = useMemo(() => {
    return featuresConfig?.find(item => item.id === PAID_FEATURE.VIP);
  }, [featuresConfig]);

  const handleClick = useCallback(() => {
    if (!isVerified) {
      login();
      return;
    }
    turnOnPaidModal();
  }, [isVerified, turnOnPaidModal]);

  const handleGotoProPage = useCallback(() => {
    history.push('/paid');
  }, [history]);

  if (isCurrentUser) {
    return (
      <>
        {currentUserInfo?.is_vip ? (
          <div className={styles.hasVip}>
            <VipLogo marginRight={4} />
            {vipLeft} {t('SendVipBtn.jrky60')}
            <div className={styles.textWithLine} onClick={handleGotoProPage}>
              {t('SendVipBtn.1s9vu03')}
              <div className={styles.line} />
            </div>
          </div>
        ) : (
          <HelperTooltip title={t('SendVipBtn.upgrade')}>
            <Button type="primary" className={styles.upgradeVIPBtn} onClick={handleGotoProPage}>
              {t('SendVipBtn.upgrade-to-vip')}
            </Button>
          </HelperTooltip>
        )}
      </>
    );
  }
  return (
    <>
      <div className={styles.sendGiftButton} onClick={handleClick}>
        <ImgRcSendGift />
        <div className={styles.textWithLine}>
          {t('SendVipBtn.sendTitle')}
          <div className={styles.line}></div>
        </div>
      </div>
      {onPaidModal ? (
        <PaidFeatureModal
          featureItem={vipFeatureConfig!}
          sendOther={true}
          turnOff={turnOffPaidModal}
          defaultTargetUserId={urlAddress}
        />
      ) : null}
    </>
  );
};
